import { render } from "./ProfileCenter.vue?vue&type=template&id=4744dc60&scoped=true"
import script from "./ProfileCenter.vue?vue&type=script&lang=js"
export * from "./ProfileCenter.vue?vue&type=script&lang=js"

import "./ProfileCenter.vue?vue&type=style&index=0&id=4744dc60&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4744dc60"]])

export default __exports__